// extracted by mini-css-extract-plugin
export default {"wrapper":"PrintBill_wrapper__gEQuX"};